export default `#version 300 es
precision mediump float;

void main() { discard; }
`